import React from "react";
import { Linkedin, Mail } from "lucide-react";
import { api } from "@/lib/api";

export default function About() {
  const [site, setSite] = React.useState(null);
  const [team, setTeam] = React.useState([]);

  React.useEffect(() => {
    api.get("/site").then((r) => setSite(r.data)).catch(() => {});
    api.get("/team").then((r) => setTeam(r.data)).catch(() => {});
  }, []);

  const s = site || {};
  const founder = team.find((m) => m.is_founder) || team[0];
  const others = team.filter((m) => m !== founder);

  return (
    <div>
      <section className="hero-mesh grain">
        <div className="container-wide py-20 md:py-28 grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <div className="overline">About Skyverra</div>
            <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight">{s.about_headline || "About Skyverra Consulting"}</h1>
            <p className="mt-6 text-[color:var(--sky-muted)] text-lg leading-relaxed max-w-3xl">{s.about_body}</p>
          </div>
          <div className="lg:col-span-4 card-flat p-6">
            <div className="overline">Founded</div>
            <div className="font-display font-bold text-3xl mt-1">{s.founded_year || "2023"}</div>
            <div className="mt-4 overline">Founder</div>
            <div className="font-display font-bold text-lg mt-1">Krutika Shah</div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="section">
        <div className="container-wide grid gap-8 md:grid-cols-2">
          <div className="card-flat p-8">
            <div className="overline">Our mission</div>
            <p className="mt-4 font-display text-2xl md:text-3xl leading-tight tracking-tight">{s.mission}</p>
          </div>
          <div className="card-flat p-8">
            <div className="overline">Our vision</div>
            <p className="mt-4 font-display text-2xl md:text-3xl leading-tight tracking-tight">{s.vision}</p>
          </div>
        </div>
      </section>

      {/* Founder */}
      {founder && (
        <section className="section bg-white border-y border-[color:var(--sky-border)]">
          <div className="container-wide grid gap-10 lg:grid-cols-12 items-center">
            <div className="lg:col-span-5">
              <div className="aspect-[4/5] rounded-md overflow-hidden border border-[color:var(--sky-border)] max-w-md">
                {founder.photo_url ? (
                  <img src={founder.photo_url} alt={founder.name} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full bg-[color:var(--sky-navy)]/10" />
                )}
              </div>
            </div>
            <div className="lg:col-span-7">
              <div className="overline">Founder introduction</div>
              <h2 className="mt-3 font-display font-bold text-3xl md:text-5xl tracking-tight">{founder.name}</h2>
              <p className="mt-2 text-[color:var(--sky-navy)] font-medium">{founder.role}</p>
              <p className="mt-5 text-[color:var(--sky-muted)] leading-relaxed max-w-2xl">{founder.bio}</p>
              <div className="mt-6 flex items-center gap-4">
                {founder.linkedin && <a href={founder.linkedin} target="_blank" rel="noreferrer" className="btn-outline text-sm"><Linkedin size={14} /> LinkedIn</a>}
                {founder.email && <a href={`mailto:${founder.email}`} className="btn-outline text-sm"><Mail size={14} /> Email</a>}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Team */}
      {others.length > 0 && (
        <section className="section">
          <div className="container-wide">
            <div className="overline">Team</div>
            <h2 className="mt-3 font-display font-bold text-3xl md:text-4xl tracking-tight">Meet the people behind Skyverra.</h2>
            <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {others.map((m) => (
                <div key={m.id} className="card-flat overflow-hidden">
                  <div className="aspect-square overflow-hidden bg-[color:var(--sky-navy)]/10">
                    {m.photo_url && <img src={m.photo_url} alt={m.name} className="w-full h-full object-cover" />}
                  </div>
                  <div className="p-5">
                    <h3 className="font-display font-bold text-lg">{m.name}</h3>
                    <p className="text-sm text-[color:var(--sky-navy)] font-medium">{m.role}</p>
                    <p className="text-sm text-[color:var(--sky-muted)] mt-2 leading-relaxed">{m.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
